export const DEBOUNCE_INPUT_TIMEOUT = 500
export const DEFAULT_FIAT_PRECISION = 2
export const DEFAULT_CRYPTO_PRECISION = 21
